import useResponsiveRedux from '../../Hooks/useResponsiveRedux';
import ListArenasMobile from '../../MobileComponents/Arena/ListArenasMobile';
import ListArenas from '../../../pages/ListArenas';

const ListArenaResponsive = () => {
    const { isMobile } = useResponsiveRedux();

    return isMobile ? <ListArenasMobile /> : <ListArenas />;
};

export default ListArenaResponsive;